import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS, KEYS, STORAGE } from '../../_config';
import { CallApi } from '../api/callApi';
//import { ACTIONS, API_URL, STORAGE } from '../../_config'

//import { CallApi, responseHandler } from '../api/callApi';
//import { UpdateWithVariables } from '../../_common/functions';
// const API_BASE_URL = process.env.REACT_APP_API_URL;


export function* login(action: any): any {
    try {
        const data = action.payload;
        //const resp = yield call(CallApi.POST, APIS.AUTH.LOGIN, data);
        const resp = yield call(CallApi.POST, APIS.AUTH.LOGIN_WITH_PERMISSION, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            const userresp = yield call(CallApi.GET, APIS.COMMON.GET_USER, { 'requestModel.id': resp.data?.authenticateDataModel?.[0]?.userID });
           // console.log("User resp is -> ", userresp);
            if (userresp.data && userresp.data?.userList && Array.isArray(userresp.data.userList) && userresp.data.userList[0]?.userTypes && Array.isArray(userresp.data.userList[0].userTypes) && userresp.data.userList[0].userTypes[0]?.userTypeID) {
                if (resp.data && resp.data?.authenticateDataModel?.[0]) {
                    resp.data.authenticateDataModel[0].userTypeID = userresp.data.userList[0].userTypes[0].userTypeID;
                }
            }
            localStorage.setItem(STORAGE, JSON.stringify(resp.data?.authenticateDataModel?.[0]));
            localStorage.setItem(KEYS.AUTH_ACCESS, resp.data?.authenticateDataModel?.[0].responseToken);
            localStorage.setItem(KEYS.AUTH_REFRESH, resp.data?.authenticateDataModel?.[0].refreshToken);

            yield put({
                type: ACTIONS.USER.LOGIN,
                payload: {
                    user: resp.data?.authenticateDataModel?.[0],
                    accessToken: resp.data?.authenticateDataModel?.[0].responseToken,
                    refreshToken: resp.data?.authenticateDataModel?.[0].refreshToken,
                    isAuthenticated: true,
                    permissions: true
                }
            })
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* register(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.AUTH.REGISTRATION, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* forgotPassword(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.AUTH.FORGOT_PASSWORD, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            // Pass the complete response data instead of resp.data.data
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            // Handle error response properly
            action && action.callbackError && action.callbackError(resp.data ? resp.data.message || resp.data.statusMessage : 'An error occurred');
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* resetPassword(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.AUTH.RESET_PASSWORD, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* getDesigns(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.GET_DESIGNS, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* saveDesign(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.SAVE_DESIGN, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* updateDesign(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.UPDATE_DESIGN, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* getImages(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.IMAGE_LIST, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
export function* uploadImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.IMAGE_UPLOAD, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.IMAGE_DELETE, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* logout(action: any): any {
    try {
        localStorage.removeItem('persist:root')
        localStorage.removeItem(STORAGE);
        localStorage.removeItem(KEYS.AUTH_ACCESS);
        localStorage.removeItem(KEYS.AUTH_REFRESH);

        yield put({
            type: ACTIONS.USER.LOGOUT,
            payload: {}
        });
        // yield put({
        //     type: ACTIONS.RESET_REDUCER,
        // });
        action && action.callbackSuccess && action.callbackSuccess({});
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


/* export function* login(action: any): any {
    action.callbackSuccess({});
}
export function* logout(action: any): any {
    action.callbackSuccess({});
} */

/* export function* restPassword(action: any): any {
    try {
        const data = action.payload;
        let API = UpdateWithVariables(API_URL.USER.RESET_PASSWORD, data.urlParams)
        if (data.urlParams) {
            delete data.urlParams
        }
        const resp = yield call(CallApi.POST, API, data, true);
        let respChecker = responseHandler(resp)
        if (respChecker.status) {
            action && action.callbackSuccess && action.callbackSuccess(respChecker.data)
        } else {
            action && action.callbackError && action.callbackError(respChecker.data)
        }
      
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* restprofilePassword(action: any): any {
    try {
        const data = action.payload;
        let API = UpdateWithVariables(API_URL.USER.PASSWORD_RESET, data.urlParams)
        if (data.urlParams) {
            delete data.urlParams
        }
        const resp = yield call(CallApi.POST, API, data, true);
        let respChecker = responseHandler(resp)
        if (respChecker.status) {
            action && action.callbackSuccess && action.callbackSuccess(respChecker.data)
        } else {
            action && action.callbackError && action.callbackError(respChecker.data)
        }
      
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}
 */

export function* saveTeamUserMapping(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.SAVE_TEAM_USER_MAPPING, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveUserModuleBundle(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.SAVE_USER_MODULE_BUNDLE, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveUserModule(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.SAVE_USER_MODULE, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteUserModule(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.USER.DELETE_USER_MODULE + "?userTypeID=" + data.userTypeID + "&name=" + data.name + "&deleteModule=true", data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* LoginWithPermissions(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.LoginWithPermissions, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getAllApiEndpoints(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.USER.GET_ALL_API_ENDPOINTS, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* getUserTypeByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.USER.GET_USER_TYPE_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getUserTypes(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.USER.GET_USER_TYPES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveUserType(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.SAVE_USER_TYPE, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteUserType(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.USER.DELETE_USER_TYPE + "?userTypeID=" + data.userTypeID, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveUser(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.SAVE_USER, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getUser(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.USER.GET_USER, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getUserModules(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.USER.GET_USER_MODULES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* getUserModuleByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.USER.GET_USER_MODULE_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* saveUserModuleApiEntity(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.USER.SAVE_USER_MODULE_API_ENTITY, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* deleteUser(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.USER.DELETE_USER+ "?RequestID=" + data.RequestID, data);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}